export const Tokens = {
    "purple": {
      "base": "#633fd3",
      "shades": {
        "50": "#c8bbf0",
        "100": "#b4a3ea",
        "200": "#a08ae4",
        "300": "#8b71de",
        "400": "#7758d9",
        "500": "#633fd3",
        "600": "#532dc6",
        "700": "#4828ad",
        "800": "#3e2294",
        "900": "#331c7b"
      }
    },
    "blue": {
      "base": "#3C55A9",
      "shades": {
        "50": "#a1afdd",
        "100": "#8a9bd5",
        "200": "#7388cd",
        "300": "#5d75c5",
        "400": "#4662bd",
        "500": "#3c55a9",
        "600": "#344a92",
        "700": "#2c3e7c",
        "800": "#243365",
        "900": "#1c284f"
      }
    },
    "background": {
      "base": "#040013",
      "shades": {
        "50": "#2400ac",
        "100": "#1e008d",
        "200": "#17006f",
        "300": "#110050",
        "400": "#0a0032",
        "500": "#040013",
        "600": "#000000",
        "700": "#000000",
        "800": "#000000",
        "900": "#000000"
      }
    },
    "gray": {
      "base": "#BEBEBE",
      "shades": {
        "50": "#ffffff",
        "100": "#fbfbfb",
        "200": "#ececec",
        "300": "#dddddd",
        "400": "#cdcdcd",
        "500": "#bebebe",
        "600": "#afafaf",
        "700": "#9f9f9f",
        "800": "#909090",
        "900": "#818181"
      }
    }
  }